import { useState } from "react";

export const useDragUploader = () => {
  const [dragged, setDragged] = useState(false);

  let draggedThrottle = false;
  // throttle function to prevent multiple calls to setDragged or not
  const setDraggedThrottle = (value) => {
    draggedThrottle = false;
    setTimeout(() => {
      if (!draggedThrottle) {
        setDragged(value);
        draggedThrottle = true;
      }
    }, 300);
  };

  const handleUploaderAddFile = (
    file: any,
    fileName: string,
    checkName: boolean
  ) => {
    const customEvent = new CustomEvent("uppy-add-file", {
      detail: {
        file,
        fileName,
        checkName,
      },
    });
    document.dispatchEvent(customEvent);
  };

  // dragging event
  const handleDrag = (e, fileName: string) => {
    e.preventDefault();
    e.stopPropagation();
    const hoveredRow = document.getElementById(fileName);

    if (e.type === "dragenter" || e.type === "dragover") {
      setDragged(true);
      if (hoveredRow) {
        hoveredRow.style.borderRadius = "10px";
        hoveredRow.style.border = "3px dashed #34A7F0";
      }
      draggedThrottle = true;
    } else if (e.type === "dragleave") {
      setDraggedThrottle(false);
      if (hoveredRow) {
        hoveredRow.style.border = "3px dashed transparent";
      }
    }
  };

  const handleDrop = async (
    e: any,
    fileName: string = "",
    multiple?: boolean,
    checkName?: boolean
  ) => {
    e.preventDefault();
    e.stopPropagation();

    setDragged(false);
    const hoveredRow = document.getElementById(fileName || "uppy-root");
    if (hoveredRow) {
      hoveredRow.style.border = "3px dashed transparent";
    }
    if (
      e.dataTransfer.files &&
      e.dataTransfer.files[0] &&
      e.dataTransfer.files[0].type !== ""
    ) {
      const files = e.dataTransfer.files;
      const filesArray = Array.from(files);
      if (multiple) {
        filesArray.forEach((file, index) => {
          handleUploaderAddFile(
            file,
            fileName || e.dataTransfer.files[index].name.split(".")[0],
            checkName
          );
        });
      } else {
        handleUploaderAddFile(
          filesArray[0],
          fileName || e.dataTransfer.files[0].name.split(".")[0],
          checkName
        );
      }
    } else {
      const files = [...e.dataTransfer.items]
        .filter((item) => item.kind === "file")
        .map((item) => item.getAsFile());
      for await (const file of files) {
        handleUploaderAddFile(
          file,
          fileName || file.name.split(".")[0],
          checkName
        );
      }
    }
  };

  return { handleDrop, handleDrag, dragged };
};
